export interface IDocusignSyncResult {
        foundSignedCreditAuth: boolean;
        foundSignedElecConsent: boolean;
        foundSignedContract: boolean;
        failMessage: string;
    }

    export class DocusignSyncResult implements IDocusignSyncResult {
        foundSignedCreditAuth: boolean;
        foundSignedElecConsent: boolean;
        foundSignedContract: boolean;
        failMessage: string;
    }